<template lang="pug">
v-layout(row, wrap).mt-2
  v-flex.xs-12(v-if="!listFaturas.length")
    span.font-weight-medium.Poppins Você não possui faturas nesse período.
  v-flex.xs12(v-else, style ="overflow-y: auto; max-height: 30vh;")
    v-card.pa-2.mb-3.cardFatura(v-for="item in listFaturas", :key="item.id")
      v-layout.pa-2(justify-center, align-center, style="cursor: pointer;", @click="$emit('showFatura', item);")
        v-flex.md7.xs7
          .body-1.font-weight-medium.Poppins {{ $dayjs(item.data_inicio).format('DD/MM/YYYY') }} - {{ $dayjs(item.data_fim).format('DD/MM/YYYY') }}
        v-flex.md4.xs4.pa-0.ma-0(style="display: flex; align-items: center;justify-content: right;")
          v-chip(small, :style="{'color': $root.getStatusFatura(item).color, 'background': $root.getStatusFatura(item).backgroundcolor }").font-weight-bold.Poppins {{$root.getStatusFatura(item).label.toUpperCase()}}
        v-flex.md1.xs1.pa-0.ma-0(style="display: flex; align-items: center;justify-content: right;")
          v-icon(color="grey") chevron_right

</template>

<script>

export default {
  props: {
    showFatura: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data () {
    return {
      faturas : []
    }
  },
  created () {
  },
  watch: {
  },
  computed: {
    listFaturas () {
      const vm = this;
      return [...vm.faturas].sort((a,b) => {
        return vm.$dayjs(b.data_fim) - vm.$dayjs(a.data_fim);
      });
    },
  },
  methods: {
    refresh(faturas){
      const vm = this;
      vm.faturas = faturas;
    }
  }
}
</script>
